var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgLongArrowLeft = function SvgLongArrowLeft(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 98,
    height: 32,
    viewBox: "0 0 98 32"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M1.084 11.747 12.494.196c.26-.261.725-.261 1.034 0l2.065 2.143c.31.261.31.732 0 1.046l-9.035 9.094c-.465.47-.104 1.306.568 1.306h90.15a.71.71 0 0 1 .724.732v2.98a.71.71 0 0 1-.723.731H7.127c-.673 0-1.034.784-.57 1.255l9.036 9.146c.259.261.259.732 0 1.045l-2.065 2.09a.74.74 0 0 1-1.084 0L1.084 20.267C.414 19.534 0 18.593 0 17.6v-3.189c0-.992.414-1.933 1.084-2.665"
  })));
};
export default SvgLongArrowLeft;